// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_layouts_demos_layout_tsx":"69a5eb2b106c9a7b","src_app_layouts_tools_layout_tsx":"303cdc2cb89ae3b1","src_app_menu_sample-data-provider_ts":"096beb9fc4a47c1d"}[chunkId] + ".js";
};